import { createApp, h } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { useAuthStore } from './stores/auth'

import './assets/global.css';

import {VueWriter} from "vue-writer";

import "mathlive";

const app = createApp({
    render: ()=>h(App)
})
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(VueWriter)

// Initialize auth store after plugins are loaded
const authStore = useAuthStore()
authStore.initialize()

app.mount('#app')